import React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ForeFlightLogo from "../../../common/ForeFlightLogo";
import JDMLogo from "../../../common/JDMLogo";

const StyledWrapper = styled('div')<{ isCompact: boolean }>`
    margin-bottom: ${({ isCompact }) => (isCompact ? '29px' : '65px')};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    a {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        color: inherit;

        .logo {
            margin-bottom: 13px;
        }
    }
`;

const Title = styled(Typography)`
    font-weight: 400;
    font-size: 30px;
    text-align: center;

    @media (max-width: 400px) {
        font-size: 25px;
    }
`;

const SubTitle = styled(Typography)`
    font-weight: 100;
    font-size: 17px;
    text-align: center;
`;

interface Props {
    show: boolean;
    showWelcomeHeader: boolean;
    username?: string;
    onReset: () => void;
}

const JeppesenHeader = ({ show, showWelcomeHeader, onReset, username = '' }: Props) => {
    if (!show) {
        return null;
    }
    return (
        <StyledWrapper isCompact={showWelcomeHeader}>
            <a href={'https://ww2.jeppesen.com'}>
                <JDMLogo />
            </a>
            {!showWelcomeHeader && (
                <>
                    <div className="jeppesen-title">
                        <Title variant="h2">Jeppesen Distribution Manager</Title>
                    </div>
                </>
            )}
            {showWelcomeHeader && (
                <>
                    <div className="jeppesen-title">
                        <Title variant="h2">Welcome!</Title>
                        <SubTitle variant="h5">{username}</SubTitle>
                    </div>
                    <Button onClick={() => onReset()}>Not you?</Button>
                </>
            )}
        </StyledWrapper>
    );
};

export default JeppesenHeader;
